<agpr-autocomplete-chips
    id="mailingLists.picker"
    field="name"
    [autocompleteOptions]="autocompleteOptions"
    [placeholder]="placeholder"
    clearAllChipsTooltip="Common.mailingLists.picker.clearAllTooltip"
    [button]="{
        icon: 'fa-regular fa-duotone fa-gear',
        tooltip: 'Common.mailingLists.picker.manage'
    }"
    [ngModel]="mailingLists"
    (ngModelChange)="updateLists()"
    (buttonPress)="openManage()"
    (allChipsRemoved)="clearAllChips($event)"
    [ariaLabel]="'Common.mailingLists.manageDialog.mailingLists.heading' | localize"
    [ariaDescribedBy]="ariaDescribedBy"
    [ariaInvalid]="ariaInvalid"
></agpr-autocomplete-chips>
